import { GoalFilterDocument } from '@griply/types';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';

export const useUpdateGoalsTimelineFilterDocument = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (filterDocument: Partial<GoalFilterDocument>) =>
      updateSettings({
        filters: {
          goalsTimeline: filterDocument,
        },
      }),
    [updateSettings],
  );
};
